import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasDraftAbandoned.meta';

export type UseTrackCanvasDraftAbandonedParams = {
  source?:
    | 'board'
    | 'library'
    | 'general_library'
    | 'asset_selection_bar'
    | 'all_content_header'
    | 'canvases'
    | 'try_canvas_cta'
    | 'board_canvas_open'
    | 'all_content_canvas_open';
  board_id?: string;
  library_id?: string;
};

export const useTrackCanvasDraftAbandoned = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasDraftAbandoned = useCallback(
    (params: UseTrackCanvasDraftAbandonedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasDraftAbandoned };
};
